var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-component"},[_c('div',{staticClass:"footer-content"},[_c('p',[_vm._v("Copyright © 2026杭州小缘文化科技有限公司出品 - 版权所有")])])])
}]

export { render, staticRenderFns }